/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ListingGrid from 'ui/components/ListingGrid.vue';
import InstalledModules from 'ui/components/InstalledModules.vue';
import PackageButton from 'ui/components/PackageButton.vue';
import UninstallPackageButton from 'ui/components/UninstallPackageButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

// Utils
import { get } from 'lodash';

/**
 * This component is the main Marketplace page controller.
 *
 * @vue-prop {Object} params the page configuration parameters.
 *
 * @category ui.pages
 * @exports Marketplace
 * @component
 */
const __vue_script__ = {
    name: 'Marketplace',

    components: { ListingGrid, InstalledModules, PackageButton, UninstallPackageButton, SearchBar },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loading: true,
            packages: [],
            libs: [],
            eventId: this.params.event.id,
            canUserInstallModules: false,
            categoriesTitles: [],
            currentDescriptions: [],
            currentLibs: [],
            orgId: this.params.event.ownerId,
            selectedCategory: 'all',
            searchTerm: '',
            searchLib: '',
            error: null
        };
    },

    watch: {
        searchTerm() {
            this.filter(this.selectedCategory);
        },

        searchLib() {
            this.filterLibs();
        },

        params: {
            handler: function(val, oldVal) {
                if (!val.category || val.category !== oldVal.category) {
                    this.filter(val.category || 'all');
                }
            },
            deep: true
        },

        selectedCategory() {
            this.trackCategory();
        }
    },

    async created() {
        let pkgs, libs;

        try {
            pkgs = await this.$services.market.getEventDescriptions(this.eventId);
            libs = await this.$services.market.getEventLibraries(this.eventId, pkgs.map(p => p.name));
        } catch (error) {
            this.error = get(error, 'response.data.error') || error.message;
            this.loading = false;

            return;
        }

        const categoriesSet = pkgs.reduce((categories, pkg) => {
            for (const cat of pkg.categories) {
                categories.add(cat);
            }
            return categories;
        }, new Set());

        this.packages = pkgs;
        this.libs = libs;
        this.categoriesTitles = Array.from(categoriesSet);

        this.canUserInstallModules = this.$services.user.hasPermission('pkg_repo_realms.manage_event_packages', { event_id: this.eventId });

        this.loading = false;

        const category = this.$router.getRouteParams().category;

        if (category && (categoriesSet.has(category) || category === 'installed')) {
            this.selectedCategory = category;
            this.filter(category);
        } else {
            this.filter();
        }

        this.filterLibs();
    },

    methods: {
        /**
         * Transforms the package data into an object suitable for the view.
         *
         * @param {Object} pkg the backend package module
         * @return {Object} an object suitable for the view
         */
        packageToTile(pkg) {
            if (this.selectedCategory === 'installed') {
                return pkg;
            }

            const classes = [];
            const badge = {};

            const userCanInstallBetaPkg = this.$services.user.hasPermission('pkg_repo_realms.install_beta_package');

            if (!pkg.installed && !pkg.deprecated && !(pkg.stage === 'beta' && !userCanInstallBetaPkg)) {
                classes.push('hovering-badge');
            }

            pkg.detailsUrl = this.$services.market.getDetailsPageUrl(this.eventId, pkg.name);

            return {
                tags: [badge],
                title: pkg.title,
                media: pkg.icon,
                tagline: pkg.tagline,
                classes: classes,
                link: pkg.detailsUrl,
                module: pkg
            };
        },

        /**
         * Filters packages based on their categories and an optional search term.
         *
         * @param {String} [category=all] the category to filter the packages with.
         */
        filter(category = 'all') {
            console.log(`[Marketplace] filtering by category ${category} and search term "${this.searchTerm}"`);

            const prevCategory = this.selectedCategory;
            let filtered = this.packages;

            // clear search when switching between installed and categories
            if (prevCategory !== category && (prevCategory === 'installed' || category === 'installed')) {
                this.clearSearch();
            }

            if (category !== 'all' && category !== 'installed') {
                filtered = filtered.filter(pkg =>
                    pkg.categories.includes(category)
                );
            }

            if (category === 'installed') {
                filtered = filtered.filter(pkg => pkg.installed);
            } else {
                filtered = filtered.filter(pkg => !pkg.deprecated);
            }

            if (this.searchTerm.length) {
                filtered = filtered.filter(this.isSearchMatch);
            }

            this.selectedCategory = category;
            this.currentDescriptions = filtered.map(this.packageToTile);
        },

        /**
         * Filters library packages based on a search term.
         */
        filterLibs() {
            console.log(`[Marketplace] filtering by search term "${this.searchLib}"`);
            if (this.searchLib.length) {
                this.currentLibs = this.libs.filter(pkg => pkg.name.indexOf(this.searchLib.trim().toLocaleLowerCase()) !== -1);
            } else {
                this.currentLibs = this.libs;
            }
        },

        /**
         * Checks if the given package matches the search term.
         *
         * @param {Object} pkg the package to match the search term with.
         *
         * @returns {Boolean} true if there's a match, false otherwise.
         */
        isSearchMatch(pkg) {
            const searchStr = `${pkg.title} ${pkg.tagline} ${this.$utils.strings.stripHTML(pkg.description)}`.toLocaleLowerCase();

            return searchStr.indexOf(this.searchTerm.trim().toLocaleLowerCase()) !== -1;
        },

        /**
         * Resets the search term.
         */
        clearSearch() {
            this.searchTerm = '';
        },

        /**
         * Tracks the clicked category.
         */
        trackCategory() {
            this.$track('bstg_nav', {
                module: 'marketplace',
                controller: 'default',
                path: `${location.pathname}/${this.selectedCategory}`,
                searchTerm: this.searchTerm
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"inner-page",attrs:{"status":_vm.loading}},[(!_vm.error && _vm.selectedCategory !== 'installed')?_c('section',{staticClass:"page-content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('marketplace.title')))]),_c('search-bar',{attrs:{"results":_vm.currentDescriptions},scopedSlots:_vm._u([(_vm.currentDescriptions.length === 0 && _vm.selectedCategory !== 'all')?{key:"no-results",fn:function(){return [_c('i18n',{attrs:{"path":"marketplace.empty_result"}},[_c('strong',[_c('em',[_vm._v(_vm._s(_vm.searchTerm))])]),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.$t(("marketplace.categories." + _vm.selectedCategory))))])])])]},proxy:true}:null],null,true),model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_c('div',{staticClass:"package-list"},[_c('listing-grid',{attrs:{"items":_vm.currentDescriptions,"event":_vm.params.event},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('package-button',{attrs:{"module":slotProps.module,"eventId":_vm.eventId,"orgId":_vm.orgId,"classes":"mini","context":"card"}})]}}],null,false,853864348)})],1)],1):_vm._e(),(!_vm.error && _vm.canUserInstallModules && _vm.selectedCategory === 'installed')?_c('installed-modules',{ref:"installedModules",attrs:{"modules":_vm.currentDescriptions,"libs":_vm.currentLibs,"event":_vm.params.event,"orgId":_vm.orgId},scopedSlots:_vm._u([{key:"search-modules",fn:function(){return [_c('search-bar',{attrs:{"results":_vm.currentDescriptions},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})]},proxy:true},{key:"search-libraries",fn:function(){return [_c('search-bar',{attrs:{"results":_vm.currentLibs},model:{value:(_vm.searchLib),callback:function ($$v) {_vm.searchLib=$$v},expression:"searchLib"}})]},proxy:true},{key:"default",fn:function(ref){
var module = ref.module;
return [_c('ul',[_c('li',[_c('uninstall-package-button',{attrs:{"module":module,"eventId":_vm.eventId,"orgId":_vm.orgId,"context":"installed-modules"}})],1)])]}}],null,false,1926342237)}):_vm._e(),(_vm.error)?_c('div',{staticClass:"alert alert-error"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Marketplace.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__